import  { AxiosResponse } from 'axios';
import React, { ChangeEvent, useState } from 'react';
import {
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Container,
  InputLabel,
  TextField
} from '@mui/material';
// eslint-disable-next-line import/no-extraneous-dependencies
import LoadingButton from '@mui/lab/LoadingButton';
import validator from 'validator';
import CustomAlert, { CustomAlertType } from '../../../Components/CustomAlert';
import MailForm from '../../../Components/Support/MailForm';
import MergeContactRequest from '../../../Model/mergeContactRequest';
import { mergeContact } from '../../../api/support';
import { useTranslation } from 'react-i18next';

const MergeAccount = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [mails, setMails] = useState<any[]>([]);
  const [contactMail, setContactMail] = useState<string>('');
  const [defaultMail, setDefaultMail] = useState<string>('');
  const [errorMessage, setErrorMessage] = useState<string>();
  const [errorType, setErrorType] = useState<CustomAlertType>();
  const [showError, setShowError] = useState<boolean>(false);

  const { t } = useTranslation();

  const onChangeValueMandatory = (e: ChangeEvent<HTMLInputElement>) => {
    const field = e.target.id;
    const { value } = e.target;

    if (field == 'primary_mail') {
      setContactMail(value);
    } else if (field == 'default_mail') {
      setDefaultMail(value);
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const onChangeMailForm = (e: any, index: number) => {
    console.log(e.target);
    const field = e.target.id;
    const mailsValue = mails;
    const { value } = e.target;
    const mailId = Number(field);
    mailsValue[mailId] = value;
    setMails(mailsValue);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const submitMerge = async (event: any) => {
    event.preventDefault();
    if (!validator.isEmail(contactMail) || !validator.isEmail(defaultMail)) {
      alert(t('EMAIL_VALIDATION'));
      return;
    } else {
      for (let i = 0; i < mails.length; i++) {
        if (!validator.isEmail(mails[i])) {
          alert(t('EMAIL_VALIDATION'));
          return;
        }
      }
    }

    let mailsNew = [];
    mailsNew.push(defaultMail);
    for (let k = 0; k < mails.length; k++) {
      mailsNew.push(mails[k]);
    }
    const submitData: MergeContactRequest = {
      mails: mailsNew
    };
    setLoading(true);

    try {
      const result: AxiosResponse = await mergeContact( encodeURIComponent(contactMail), submitData);
      if (result.data.success) {
        alert('Successfully merged account');
      }
    } catch (error: any) {
      setShowError(true);
      setErrorMessage(error.response.data.errorMessage);
      setErrorType(CustomAlertType.ALERT);
    } finally {
      setLoading(false);
    }
  };

  const createrandomID = () => {
    const id = Date.now();
    return id;
  };

  return (
    <Container>
      <Card sx={{ maxWidth: 600, padding: 0 }} style={{ margin: 'auto' }}>
        <CardHeader
          style={{ backgroundColor: 'rgba(0, 0, 0, 0.125)' }}
          subheader={t('MERGE_ACCOUNT')}
        ></CardHeader>
        <Box
          sx={{
            width: 'auto',
            maxWidth: '100%'
          }}
        >
           <form onSubmit={submitMerge}>
            <CardContent>
            <InputLabel>{t('WILL_STAY_ACTIVE')}</InputLabel>
              <TextField
                 sx={{
                   '& legend': { display: 'none' },
                   '& fieldset': { top: 0 }
                 }}
                size='small'
                fullWidth
                id="primary_mail"
                value={contactMail}
                onChange={onChangeValueMandatory}
              />
              <h2>
                <div className="float-right" style={{ marginBottom: '0.2em' }}>
                  <Button
                    variant="contained"
                    size="small"
                    onClick={() => {
                      setMails([...mails, '']);
                    }}
                  >
                    {t('+')}
                  </Button>
                </div>
              </h2>
              <InputLabel>{t('WILL_STAY_REMOVED')}</InputLabel>
              <TextField
               sx={{
                 '& legend': { display: 'none' },
                 '& fieldset': { top: 0 }
               }}
              size="small"
                fullWidth
                id="default_mail"
                value={defaultMail}
                onChange={onChangeValueMandatory}
              />
              {mails?.map(
                (mail: string, index: number) => (
                  <>
                    <MailForm
                      index={index}
                      key={createrandomID()}
                      mail={mail}
                      onChangeValue={(e) => onChangeMailForm(e, index)}
                    />
                    <div className="text-right mb-1">
                      <Button
                        size="small"
                        color="error"
                        variant="contained"
                        onClick={() => {
                          const mailsValue = [...mails];
                          mailsValue?.splice(index, 1);
                          setMails(mailsValue);
                        }}
                      >
                        {t('REMOVE_MAIL')}
                      </Button>
                    </div>
                  </>
                )
              )}
            </CardContent>
            <CardActions>
              <LoadingButton
                loading={loading}
                variant="contained"
                style={{
                  marginLeft: 'auto',
                  marginRight: 10,
                  marginBottom: 10
                }}
                type="submit"
              >
                {t('MERGE')}
              </LoadingButton>
            </CardActions>
            </form>
        </Box>
      </Card>
      <CustomAlert
        type={errorType}
        show={showError}
        message={errorMessage}
        onClose={() => {
          setShowError(false);
          setErrorMessage('');
        }}
      />
    </Container>
  );
};

export default MergeAccount;
